import React from 'react';
import { Grid, CircularProgress } from '@material-ui/core';
import { useStyles } from './styles';

const Loader = ({ withBackdrop, size = 40, color }) => {
  const classes = useStyles({ withBackdrop, color });
  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.root}>
      <CircularProgress size={size} />
    </Grid>
  );
};

const Loading = props => <Loader {...props} />;

export default Loading;
